var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.626 22.0835L19.9583 17.6373V12.1668C19.9583 9.43276 17.734 7.2085 14.9999 7.2085C12.2658 7.2085 10.0416 9.43276 10.0416 12.1668V17.6373L7.37384 22.0835H12.9989C13.2916 22.9075 14.0768 23.5002 14.9999 23.5002C15.923 23.5002 16.7083 22.9075 17.0009 22.0835H22.626ZM11.4583 18.0297V12.1668C11.4583 10.214 13.0471 8.62516 14.9999 8.62516C16.9528 8.62516 18.5416 10.214 18.5416 12.1668V18.0297L20.1238 20.6668H9.876L11.4583 18.0297ZM2.24992 15.0002C2.24992 22.0306 7.9695 27.7502 14.9999 27.7502C22.0303 27.7502 27.7499 22.0306 27.7499 15.0002C27.7499 7.96975 22.0303 2.25016 14.9999 2.25016C11.1477 2.25016 7.7414 4.00366 5.31761 7.2085H10.7499V7.42028C10.3528 7.77626 10.0002 8.18083 9.70218 8.62516H2.95825V0.833496H4.37492V6.10997C7.05778 2.69673 10.7863 0.833496 14.9999 0.833496C22.8115 0.833496 29.1666 7.18861 29.1666 15.0002C29.1666 22.8117 22.8115 29.1668 14.9999 29.1668C7.18836 29.1668 0.833252 22.8117 0.833252 15.0002H2.24992Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.292784b4ec8df4a42b45ac4aeb1ac941.svg";
export { ForwardRef as ReactComponent };